/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  Card,
  CardContent,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import PersonIcon from "@mui/icons-material/Person";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import AddUser from "./AddUser";
import API from "../../Utils/Interceptor/ApiMiddleware";
import CustomSnackbar from "../../components/Composables/CustomSnackBarMenu";
import DeleteCanidateDrawer from "../../components/Composables/deleteCandidateDrawer";
import PauseResumeCanidateDrawer from "../../components/Composables/pauseResumeCandidateDrawer";
import PersonAddAlt1OutlinedIcon from "@mui/icons-material/PersonAddAlt1Outlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import WorkHistoryOutlinedIcon from "@mui/icons-material/WorkHistoryOutlined";
import LoadingSpinner from "../../components/Composables/CircularProgressBar";

const UserDetails = () => {
  const [candidateData, setCandidateData] = useState(false);
  const [backbutton, setbackbutton] = useState(false);
  const navigate = useNavigate();
  const [addUserDialog, setAddUserDialog] = useState(false);
  const location = useLocation();
  const { id } = location.state || {};
  const defaultSelectedAdminRef = useRef(null);
  const tempSelectedCompanyAdmin = useRef(null);
  const [open, setOpen] = useState(false);
  const [roleList, setRoleList] = useState([]);
  const [underAssignRole, setUnderAssignRole] = useState();
  const [basicInfo, setBasicInfo] = useState([{}]);
  const [acknowledged, setAcknowledged] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  const [openDialog, setOpenDialog] = useState(false);

  const userDetails = async () => {
    setLoading(true);
    try {
      const response = await API.get(`user/get-user-company-details/${id}`);
      const selectedAuthorizename = {
        id: response.data.data?.["Basic Info"]?.under_assigned_user_id,
        name: response.data.data?.["Basic Info"]?.under_assigned_user_name,
        username: response.data.data?.["Basic Info"]?.user_name,
        user_id: response.data.data?.["Basic Info"]?.user_id,
        hierarchy_id: response.data.data?.hierarchyId?.hierarchyId,
      };
      console.log("Data of the response ", response.data.data);
      defaultSelectedAdminRef.current = selectedAuthorizename;
      setCandidateData(response.data.data);
      setBasicInfo(response.data.data?.["Basic Info"]);
    } catch (error) {
      console.error("Error fetching user data:", error.message);
    } finally {
      setLoading(false);
    }
  };
  const formattedBasicInfo = {
    "First Name": basicInfo?.firstName || "NA",
    "Last Name": basicInfo?.lastName || "NA",
    Email: basicInfo?.email || "NA",
    "Role Type": basicInfo?.role_name || "NA",
    "Assigned Under": basicInfo?.under_assigned_user_name || "NA",
  };
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setAcknowledged(false);
    setUnderAssignRole();
  };
  useEffect(() => {
    userDetails();
  }, []);
  const handleunderAssignRole = (event) => {
    const selectedUserId = event.target.value;
    const selectedUser = roleList.find(
      (user) => user.user_id === selectedUserId
    );
    setUnderAssignRole(selectedUser);
  };

  const fetchChildAuthority = async (roleId, userId) => {
    try {
      const response = await API.post("/user/get-child-authority", {
        user_id: candidateData?.["Basic Info"]?.emp_user_id,
        role_id: candidateData?.["Basic Info"]?.role_id,
      });

      const list = response.data.data;
      setRoleList(list);
    } catch (error) {
      console.error(error);
    }
  };

  const handleAcknowledgeChange = (event) => {
    setAcknowledged(event.target.checked);
  };
  const handleDelete = () => {
    if (!(acknowledged && underAssignRole?.user_id)) {
      return;
    } else {
      try {
        const response = API.post(`/user/delete-user/${id}`, {
          under_assigned_user_id: underAssignRole?.user_id,
          emp_user_id: basicInfo?.emp_user_id,
        });
        if (response) {
          setSnackbar({
            open: true,
            message: "User deleted successfully",
            severity: "success",
          });
          setTimeout(() => {
            navigate(-1);
          }, 1000);
        } else {
          setSnackbar({
            open: true,
            message: "Error deleting user",
            severity: "error",
          });
        }
      } catch (err) {
        console.error(err);
        setAcknowledged(false);
        setUnderAssignRole({});
      } finally {
        setOpen(false);
        setAcknowledged(false);
      }
    }
  };
  const handlePauseResume = async () => {
    if (!acknowledged) {
      return;
    } else {
      try {
        setOpenDialog(false);
        setAcknowledged(false);
        const response = await API.post(`/user/pause-resume-user`, {
          is_pause: basicInfo?.Status === "Paused" ? 0 : 1,
          user_id: basicInfo?.user_id,
          emp_user_id: basicInfo?.emp_user_id,
        });

        if (response.data.message === 200) {
          setSnackbar({
            open: true,
            message: `User ${
              basicInfo?.Status === "Paused" ? "resumed" : "paused"
            } successfully`,
            severity: "success",
          });
          setTimeout(() => {
            userDetails();
          }, 1000);
        } else if (response.data.message === 400) {
          setSnackbar({
            open: true,
            message: `Error in ${
              basicInfo?.Status === "Paused" ? "resuming" : "pausing"
            } user`,
            severity: "warning",
          });
        }
      } catch (err) {
        console.error(err);
        setSnackbar({
          open: true,
          message: err.response.data.message,
          severity: "warning",
        });
        setAcknowledged(false);
        setUnderAssignRole({});
      } finally {
        setOpen(false);
        setAcknowledged(false);
      }
    }
  };
  useEffect(() => {
    if (open) {
      fetchChildAuthority();
    } else {
      return;
    }
  }, [open]);
  const handleOpenDialog = () => {
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setAcknowledged(false);
  };

  const getIcon = (comment) => {
    if (comment?.includes("applied")) {
      return (
        <Box
          className="icon-container"
          sx={{
            border: " 1px solid rgba(33, 150, 243, 0.20)",
            borderRadius: "10px",
            height: "44px",
            minWidth: "44px",

            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            transition: "background-color 0.5s",
          }}
        >
          <PersonOutlineOutlinedIcon
            className="icon"
            style={{ color: "#979797" }}
          />
        </Box>
      );
    } else if (comment?.includes("created")) {
      return (
        <Box
          className="icon-container"
          sx={{
            border: " 1px solid rgba(255, 169, 60, 0.20)",
            borderRadius: "10px",
            height: "44px",
            minWidth: "44px",

            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            transition: "background-color 0.5s",
          }}
        >
          <PersonAddAlt1OutlinedIcon
            className="icon"
            style={{ color: "#979797" }}
          />
        </Box>
      );
    } else {
      return (
        <Box
          className="icon-container"
          sx={{
            border: " 1px solid rgba(76, 175, 80, 0.20)",
            borderRadius: "10px",
            height: "44px",
            minWidth: "44px",

            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            transition: "background-color 0.5s",
          }}
        >
          <WorkHistoryOutlinedIcon
            className="icon"
            style={{ color: "#979797" }}
          />
        </Box>
      );
    }
  };

  const getColor = (comment) => {
    if (comment?.includes("applied")) {
      return "#2196F3";
    } else if (comment?.includes("created")) {
      return "#FFA93C";
    } else {
      return "#4CAF50 ";
    }
  };

  return (
    <Box
      sx={{
        padding: "16px",
        backgroundColor: "#E3F2FD",
        height: "100%",
        borderRadius: "24px 0 0 0",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#FFF",
          padding: "16px",
          borderRadius: "12px",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <LoadingSpinner />
          </Box>
        ) : (
          <>
            {/* Header Section */}
            <Box
              sx={{
                display: "flex",
                borderBottom: "1px solid rgba(21, 29, 72, 0.12)",
                paddingBottom: "16px",
                // marginBottom: "20px",
                gap: "12px",
                alignItems: "center",
              }}
            >
              <Button
                startIcon={
                  <ChevronLeftOutlinedIcon
                    style={{ height: "16px", width: "16px" }}
                  />
                }
                sx={{
                  "& .MuiButton-startIcon": backbutton
                    ? { marginRight: "4px !important" }
                    : { margin: "0px" },
                }}
                style={
                  backbutton
                    ? {
                        backgroundColor: "#3F95EA",
                        color: "white",
                        height: "24px",
                        fontSize: "12px",
                        textTransform: "none",
                      }
                    : {
                        backgroundColor: "#E7E7E7",
                        color: "#1A1A1A",
                        minWidth: "24px",
                        height: "24px",
                        padding: "4px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }
                }
                onMouseEnter={() => setbackbutton(true)}
                onMouseLeave={() => setbackbutton(false)}
                onClick={() => navigate(-1)}
              >
                {backbutton ? "Back" : ""}
              </Button>
              <Typography sx={{ fontSize: "22px", fontWeight: 600 }}>
                User Details
              </Typography>
            </Box>

            {/* User Top Info */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Box sx={{ display: "flex", gap: "16px", alignItems: "center" }}>
                <Box
                  sx={{
                    width: "100px",
                    height: "100px",
                    backgroundColor: "#E3F2FD",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <PersonIcon sx={{ fontSize: "100px", color: "#979797" }} />
                </Box>

                <Box>
                  <Typography fontSize={"20px"} fontWeight={600}>
                    {candidateData?.["Basic Info"]?.firstName +
                      " " +
                      candidateData?.["Basic Info"]?.lastName}
                  </Typography>
                  <Typography sx={{ fontSize: "14px", color: "#00000099" }}>
                    {candidateData?.["Basic Info"]?.role_name || "Role"}
                  </Typography>
                </Box>
              </Box>
              {basicInfo?.Status !== "Deleted" ? (
                <Box>
                  <Button
                    variant="outlined"
                    sx={{ marginRight: "16px" }}
                    startIcon={<ModeEditIcon />}
                    onClick={() => setAddUserDialog(true)}
                  >
                    EDIT
                  </Button>
                  <Button
                    variant="outlined"
                    color={
                      basicInfo?.Status === "Paused" ? "success" : "warning"
                    }
                    sx={{ marginRight: "16px" }}
                    startIcon={
                      basicInfo?.Status === "Paused" ? (
                        <PlayCircleIcon />
                      ) : (
                        <PauseCircleOutlineIcon />
                      )
                    }
                    onClick={handleOpenDialog}
                  >
                    {basicInfo?.Status === "Paused" ? "RESUME" : "PAUSE"}
                  </Button>
                  <Button
                    startIcon={<DeleteOutlineOutlinedIcon />}
                    variant="outlined"
                    color="error"
                    sx={{ alignSelf: "flex-start" }}
                    onClick={handleOpen}
                  >
                    DELETE
                  </Button>
                </Box>
              ) : null}
            </Box>

            {/* Tabs */}
            <Tabs
              value={"UserInfo"}
              style={{
                // margin: "20px 0px",
                borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
              }}
              sx={{
                "& .MuiTabs-indicator": {
                  height: "2px",
                },
              }}
            >
              <Tab
                value="UserInfo"
                label="USER INFO"
                sx={{
                  fontWeight: "500",
                  fontSize: "14px",
                }}
              />
            </Tabs>

            {/* Candidate Data Cards */}
            <Box
              sx={{
                display: "flex",
                // flexDirection: "row",
                gap: "16px",
                width: "100%",
                height: "calc(100% - 250px)",
              }}
            >
              {Object.keys(candidateData)?.map((section) =>
                section !== "hierarchyId" ? (
                  <Card
                    key={section}
                    elevation={0}
                    sx={{
                      borderRadius: "4px",
                      border: "1px solid rgba(115, 119, 145, 0.08)",
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      maxHeight: "100%",
                      overflow: "hidden",
                    }}
                  >
                    <Box
                      sx={{
                        borderRadius: "4px 4px 0 0",
                        padding: "14px 20px",
                        backgroundColor: "rgba(63, 149, 234, 0.20)",
                        color: "#000",
                        fontSize: "14px",
                        fontWeight: "600",
                        flexShrink: 0,
                      }}
                    >
                      {section}
                    </Box>

                    <CardContent
                      sx={{
                        padding: "16px 20px",
                        flexGrow: 1,
                        overflowY: "auto",
                        display:
                          section === "Recent Activities" ? "flex" : "block",
                        gap: "10px",
                        flexDirection: "column",
                      }}
                    >
                      {section === "Basic Info" ? (
                        Object.entries(formattedBasicInfo).map(
                          ([key, value]) => (
                            <Box
                              key={key}
                              sx={{
                                marginBottom: "8px",
                                display: "flex",
                                gap: "20px",
                              }}
                            >
                              <Typography
                                sx={{
                                  textTransform: "capitalize",
                                  fontWeight: "400",
                                  fontSize: "14px",
                                  color: "rgba(0, 0, 0, 0.60)",
                                  width: "150px",
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                }}
                              >
                                {key}
                              </Typography>
                              <Typography
                                sx={{
                                  fontWeight: "400",
                                  fontSize: "14px",
                                  color: "rgba(0, 0, 0, 0.87)",
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                  flex: 1,
                                }}
                              >
                                {value}
                              </Typography>
                            </Box>
                          )
                        )
                      ) : section === "Companies List" ? (
                        candidateData?.[section]?.length > 0 ? (
                          candidateData?.[section]?.map((company, idx) => (
                            <Box key={idx} sx={{ marginBottom: "8px" }}>
                              <Box
                                sx={{
                                  display: "grid",
                                  gridTemplateColumns: "100px auto",
                                  gap: "20px",
                                  alignItems: "start",
                                }}
                              >
                                <Typography
                                  sx={{
                                    textTransform: "capitalize",
                                    fontWeight: "400",
                                    fontSize: "14px",
                                    color: "rgba(0, 0, 0, 0.60)",
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {company?.name}
                                </Typography>

                                <Box
                                  sx={{
                                    display: "flex",
                                    gap: "10px",
                                    flexWrap: "wrap",
                                  }}
                                >
                                  {company?.branches?.length > 0 ? (
                                    company?.branches?.map((branch, idx) => (
                                      <Box
                                        key={idx}
                                        sx={{
                                          fontSize: "12px",
                                          padding: "4px 10px",
                                          backgroundColor: "#E3F2FD",
                                          borderRadius: "16px",
                                          color: "#333",
                                        }}
                                      >
                                        {branch?.branch_name}
                                      </Box>
                                    ))
                                  ) : (
                                    <Typography
                                      sx={{
                                        fontWeight: "400",
                                        fontSize: "14px",
                                        color: "rgba(0, 0, 0, 0.87)",
                                        whiteSpace: "normal",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      No branches available
                                    </Typography>
                                  )}
                                </Box>
                              </Box>
                            </Box>
                          ))
                        ) : (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "100%",
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: 700,
                                fontSize: "14px",
                                color: "text.secondary",
                                textAlign: "center",
                              }}
                            >
                              No companies available
                            </Typography>
                          </Box>
                        )
                      ) : section === "Recent Activities" ? (
                        Array.isArray(candidateData?.[section]) &&
                        candidateData?.[section]?.length > 0 ? (
                          candidateData?.[section]?.map(
                            (item, index) =>
                              item?.notes && (
                                <Box
                                  key={index}
                                  display={{
                                    xs: "block",
                                    md: "block",
                                    lg: "flex",
                                  }}
                                  alignItems={"center"}
                                  gap={"14px"}
                                  sx={{
                                    "&:hover .icon-container": {
                                      backgroundColor: getColor(item?.notes),
                                    },
                                    "&:hover .icon": {
                                      color: "white !important",
                                    },
                                    "&:hover .activity-logs": {
                                      fontWeight: "500 !important",
                                    },
                                  }}
                                >
                                  {getIcon(item?.notes)}
                                  <Box overflow="hidden">
                                    <Typography
                                      className="activity-logs"
                                      sx={{
                                        fontWeight: 400,
                                        textOverflow: "ellipsis",
                                        overflow: "hidden",
                                        whiteSpace: "wrap",
                                        fontSize: "14px",
                                        color: "#151D48",
                                        marginBottom: "2px",
                                      }}
                                    >
                                      {item?.notes}
                                    </Typography>
                                    <Typography
                                      sx={{ fontWeight: 400 }}
                                      variant="body2"
                                      color="#737791"
                                      fontSize={"10px"}
                                    >
                                      {item?.date_modified}
                                    </Typography>
                                  </Box>
                                </Box>
                              )
                          )
                        ) : (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "100%",
                            }}
                          >
                            <Typography
                              variant="body1"
                              color="textSecondary"
                              sx={{
                                fontSize: "14px",
                                fontWeight: 700,
                                textAlign: "center",
                              }}
                            >
                              No Recent Activities
                            </Typography>
                          </Box>
                        )
                      ) : null}
                    </CardContent>
                  </Card>
                ) : null
              )}
            </Box>
          </>
        )}
      </Box>

      <DeleteCanidateDrawer
        open={open}
        roleList={roleList}
        handleunderAssignRole={handleunderAssignRole}
        underAssignRole={underAssignRole}
        usersection={true}
        basicInfo={basicInfo}
        handleClose={handleClose}
        acknowledged={acknowledged}
        handleDelete={handleDelete}
        handleAcknowledgeChange={handleAcknowledgeChange}
      />
      <PauseResumeCanidateDrawer
        open={openDialog}
        basicInfo={basicInfo}
        handleClose={handleCloseDialog}
        handleDelete={handlePauseResume}
        acknowledged={acknowledged}
        handleAcknowledgeChange={handleAcknowledgeChange}
      />
      <CustomSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar({ open: false, message: "", severity: "" })}
      />
      <AddUser
        open={addUserDialog}
        onClose={() => setAddUserDialog(false)}
        apiData={candidateData}
        id={id}
        defaultSelectedAdminRef={defaultSelectedAdminRef}
        tempSelectedCompanyAdmin={tempSelectedCompanyAdmin}
      />
    </Box>
  );
};

export default UserDetails;
